var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import compose from 'recompose/compose';
import { injectIntl } from 'react-intl';
import WithValidation from '../../lib/WithValidation';
import require from '../../lib/WithValidation/rules/required';
import marked from 'marked';
import ResponsibleGamingAccordionSignUp from '../ResponsibleGamingAccordionSignUp';
import PropTypes from 'prop-types';
import Icon from '../../components/Icon';
import Translate from '../../components/Translate';
import translate from '../../lib/utils/translate';

var SetLimits = function (_Component) {
  _inherits(SetLimits, _Component);

  function SetLimits() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SetLimits);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SetLimits.__proto__ || Object.getPrototypeOf(SetLimits)).call.apply(_ref, [this].concat(args))), _this), _this._MgaForm = function () {
      var _this$props = _this.props,
          showLimits = _this$props.showLimits,
          intl = _this$props.intl,
          onGoBack = _this$props.onGoBack,
          onShowLimits = _this$props.onShowLimits;


      return React.createElement(
        'div',
        { className: 'optional-limits' },
        showLimits && React.createElement(
          'div',
          { className: 'layout-item buttons' },
          React.createElement(
            'div',
            { className: 'backButton layout-item-6' },
            React.createElement(Icon, { icon: 'angle-left' }),
            React.createElement(
              'a',
              { type: 'button', className: 'wide', onClick: onGoBack },
              translate({
                id: 'action.button.previous',
                defaultMessage: 'Previous'
              }, intl)
            )
          ),
          React.createElement(
            'div',
            { className: 'layout-item-6' },
            React.createElement(
              'button',
              {
                type: 'submit',
                onClick: onShowLimits,
                className: 'button primary wide' },
              translate({
                id: 'action.button.continue',
                defaultMessage: 'Continue'
              }, intl)
            )
          )
        ),
        !showLimits && React.createElement(
          'div',
          { className: 'layout-item buttons' },
          React.createElement(
            'div',
            { className: 'layout-item-4' },
            React.createElement(
              'button',
              { className: 'button secondary wide', type: 'submit' },
              translate({
                id: 'action.button.no.limits',
                defaultMessage: 'No'
              }, intl)
            )
          ),
          React.createElement(
            'div',
            { className: 'layout-item-4' },
            React.createElement(
              'button',
              {
                type: 'button',
                onClick: onShowLimits,
                className: 'button primary wide' },
              translate({
                id: 'action.button.yes.limits',
                defaultMessage: 'Yes'
              }, intl)
            )
          ),
          React.createElement(
            'div',
            { className: 'backButton layout-item-6' },
            React.createElement(Icon, { icon: 'angle-left' }),
            React.createElement(
              'a',
              { type: 'button', className: 'wide', onClick: onGoBack },
              translate({
                id: 'action.button.previous',
                defaultMessage: 'Previous'
              }, intl)
            )
          )
        )
      );
    }, _this._UkForm = function () {
      var _this$props2 = _this.props,
          onGoBack = _this$props2.onGoBack,
          intl = _this$props2.intl;

      return React.createElement(
        'div',
        { className: 'layout-item buttons' },
        React.createElement(
          'div',
          { className: 'backButton layout-item-6' },
          React.createElement(Icon, { icon: 'angle-left' }),
          React.createElement(
            'a',
            { type: 'button', className: 'wide', onClick: onGoBack },
            translate({
              id: 'action.button.previous',
              defaultMessage: 'Previous'
            }, intl)
          )
        ),
        React.createElement(
          'div',
          { className: 'layout-item-6' },
          React.createElement(
            'button',
            { className: 'button primary wide', type: 'submit' },
            translate({
              id: 'action.button.continue',
              defaultMessage: 'Continue'
            }, intl)
          )
        )
      );
    }, _this._GenerateForm = function () {
      var jurisdiction = _this.props.jurisdiction;


      switch (jurisdiction.toLowerCase()) {
        case 'uk':
          return _this._UkForm();
        case 'mga':
          return _this._MgaForm();
        default:
          return _this._MgaForm();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SetLimits, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onSubmit = _props.onSubmit,
          responsibleGamingData = _props.responsibleGamingData,
          handleSetLimits = _props.handleSetLimits,
          limitsData = _props.limitsData,
          currency = _props.currency,
          onCancel = _props.onCancel,
          mga = _props.mga,
          showLimits = _props.showLimits;


      var items = responsibleGamingData && responsibleGamingData.items && responsibleGamingData.items.map(function (i) {
        return _extends({}, i, {
          content: i.content && marked(i.content)
        });
      });

      return React.createElement(
        'div',
        { className: 'set-limit-reg-form' },
        mga && !showLimits && React.createElement(
          'div',
          { className: 'showLimitsQuestion' },
          React.createElement(Translate, {
            id: 'label.set.limits.question',
            defaultMessage: 'Do you want to set limits for your account?',
            tagName: 'p'
          })
        ),
        mga && showLimits ? React.createElement(ResponsibleGamingAccordionSignUp, {
          data: items,
          onSubmitForm: handleSetLimits,
          limitsData: limitsData,
          currency: currency,
          onCancel: onCancel
        }) : !mga && React.createElement(ResponsibleGamingAccordionSignUp, {
          data: items,
          onSubmitForm: handleSetLimits,
          limitsData: limitsData,
          currency: currency,
          onCancel: onCancel
        }),
        React.createElement(
          'form',
          { onSubmit: onSubmit },
          this._GenerateForm()
        )
      );
    }
  }]);

  return SetLimits;
}(Component);

SetLimits.propTypes = {
  /** Submits the form */
  onSubmit: PropTypes.func,
  /** Gives access to translation api */
  intl: PropTypes.object,
  /** responsible gaming data from contenful */
  responsibleGamingData: PropTypes.object,
  /** Goes back one step in the signup process */
  onGoBack: PropTypes.func,
  /** Handler for the form submission of the limits */
  handleSetLimits: PropTypes.func,
  /** Data of all the current and newly setted limits */
  limitsData: PropTypes.array,
  /** currency of the player */
  currency: PropTypes.string,
  /** Cancellation handler for cancelling limits */
  onCancel: PropTypes.func
};


var rules = {
  activation_code: [[require, 'error.empty.activation_code']]
};

export default compose(WithValidation(rules), injectIntl)(SetLimits);